import urlContainsParam from './url/url-contains-param';

const isMobileAppWebview = () => urlContainsParam('mobileApp');

export default isMobileAppWebview;
